import Loader from './Loader.js';
import React, { useState, useLayoutEffect } from 'react';
import * as generic from './generic.js';

export default function useLoadState(initialState, dependencyList, request, onsuccess, hideLoader) {
	const [ state, setState ] = useState({ ...initialState });
	const [ loadingState, setLoadingState ] = useState({ loading: true, error: null, first: true });

	function effect() {
		let callserverRequest = (typeof(request) === "function") ? request() : request;
		setLoadingState((loadingState) => ({ loading: true, error: null, first: loadingState.first }));
		generic.callserver(
			callserverRequest,
			(result) => {
				onsuccess(result)
				setLoadingState({ loading: false, error: null, first: false });
			},
			(error) => {
				setLoadingState({ loading: false, error: error, first: false });
				setState(initialState);
			}
		);
	};

	function useRender(realRender) {
		useLayoutEffect(effect, (typeof(dependencyList) === "function") ? dependencyList() : dependencyList);

		if (loadingState.error) {
			return <div>Error: {loadingState.error.message}</div>;
		} else if (loadingState.loading && (!hideLoader || loadingState.first)) {
			return <Loader text="useLoadState"/>;
		} else {
			return realRender();
		}
	};

	return [
		state, setState, useRender, loadingState, setLoadingState
	];

}
